var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedIn = function SvgLinkedIn(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#335CFF",
    d: "M4.446 2.7a1.8 1.8 0 1 1-3.6-.002 1.8 1.8 0 0 1 3.6.002M4.5 5.832H.9V17.1h3.6zm5.688 0H6.606V17.1h3.546v-5.913c0-3.294 4.293-3.6 4.293 0V17.1H18V9.963c0-5.553-6.354-5.346-7.848-2.619z"
  })));
};
export default SvgLinkedIn;